import defineComponent from 'flight'

function GptLogger() {

    this.defaultAttrs({
    });

    this._slotLoadTimings = [];

    this._loadingSlot = function (evt, payload) {
        let name = 'gpt.loading.' + payload.position + '.begin';
        this._slotLoadTimings[payload.position] = new Date().getTime();

        this._incrementCounter(name);
    };

    this._slotLoaded = function (evt, payload) {
        let name = 'gpt.loading.' + payload.position;
        let start = this._slotLoadTimings[payload.position];
        let stop = new Date().getTime();

        this._incrementCounter(name + '.end');
        this._timing(name, stop - start);
    };

    this._adsNotBlocked = function () {
        this._incrementCounter('gpt.not_blocked');
    };

    this._adsBlocked = function () {
        this._incrementCounter('gpt.blocked');
    };

    this._analyticsNotBlocked = function () {
        this._incrementCounter('gpt.ga_not_blocked');
    };

    this._analyticsBlocked = function () {
        this._incrementCounter('gpt.ga_blocked');
    };

    this._incrementCounter = function (name) {
        let payload = {
            eventName: 'increment-counter',
            name: name
        };

        this.trigger(document, 'data:scribe', payload);
    };

    this._timing = function (name, ms) {
        let payload = {
            eventName: 'timing',
            name: name + '.ms',
            ms: ms
        };

        this.trigger(document, 'data:scribe', payload);
    };

    this._checkForAdBlocker = function () {
        let querystring = ['a', 'd', 'v', 'e', 'r', 't', 'i', 's', 'e', 'm', 'e', 'n', 't', '=', 'a', 'd', 't', 'e', 'c', 'h', '|', 't', 'r', 'a', 'd', 'e', 'd', 'o', 'u', 'b', 'l', 'e', 'r', '|', 'a', 'd', 't', 'r', 'a', 'c', 'k', 'i', 'n', 'g', '|', 'a', 'd', 's'];
        let url = '/fusion/check?' + querystring.join('');
        $.get(url)
            .done(function () {
                this._adsNotBlocked();
            }.bind(this))
            .fail(function () {
                this._adsBlocked();
            }.bind(this));
    };

    this._checkForAnalyticsBlocker = function () {
        let querystring = ['_', '_', 'u', 't', 'm', '.', 'g', 'i', 'f'];
        let url = '/fusion/check/' + querystring.join('');
        $.get(url)
            .done(function () {
                this._analyticsNotBlocked();
            }.bind(this))
            .fail(function () {
                this._analyticsBlocked();
            }.bind(this));
    };

    this.after('initialize', function () {
        if (document.location.protocol === 'https:') {
            return;
        }

        this.on(document, 'ui:gpt:loading-slot', this._loadingSlot);
        this.on(document, 'ui:gpt:slot-loaded', this._slotLoaded);
        this.on(document, 'ui:gpt:start-loading-ads', function () {
            this._slotLoadTimings = [];
        });

        this._checkForAdBlocker();
        this._checkForAnalyticsBlocker();
    });

}

export default defineComponent.component(GptLogger);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/layout/ads/gpt-logger.js